import {
  FunctionComponent,
  useEffect,
  useState,
  useCallback,
  ChangeEvent,
} from 'react'
import { MdPlayArrow } from 'react-icons/md'
import * as Yup from 'yup'

import Scaffold from 'shared/components/ScaffoldNew'
import { colors } from 'shared/styles/colors'
import Input from 'shared/components/Input'

import { useMotoristas } from '../../../../hooks/useMotoristas'
import { IEmailComponentsProps } from './EmailComponents.types'
import {
  Container,
  Title,
  ContainerForm,
  StyledForm,
  Label,
  ContainerSwitch,
} from './styles'
import Switch from 'shared/components/Switch'

const Email: FunctionComponent<IEmailComponentsProps> = () => {
  const { handleBackButton, handleNextButton, loading } = useMotoristas()
  const [formOk, setFormOk] = useState(false)
  const [informarEmail, setInformarEmail] = useState(true)
  const { motoristas, setMotoristas } = useMotoristas()
  const [errorMessage] = useState('')
  const [email] = useState(() => {
    if (motoristas && motoristas.email) {
      return motoristas.email
    }

    return ''
  })

  useEffect(() => {
    if (motoristas && (motoristas.email || !informarEmail)) {
      setFormOk(true)
    } else {
      setFormOk(false)
    }
  }, [motoristas, setFormOk, informarEmail])

  const handleChange = useCallback(
    async (e: ChangeEvent<HTMLInputElement>) => {
      setFormOk(false)
      const textValue = e.target.value

      if (!textValue) {
        setMotoristas({ email: null })

        return
      }

      try {
        const schema = Yup.object().shape({
          email: Yup.string().required().email(),
        })

        await schema.validate(
          {
            email: textValue,
          },
          {
            abortEarly: false,
          },
        )

        setMotoristas({ email: textValue })
        setFormOk(true)
      } catch (e) {
        setFormOk(false)
      }
    },
    [setMotoristas, setFormOk],
  )

  return (
    <Scaffold
      showFooterScaffold
      titleBackButton="Voltar"
      onClickBackButton={handleBackButton}
      icon={MdPlayArrow}
      titleNextButton="Próximo"
      onClickNextButton={handleNextButton}
      isNextButtonDisabled={!formOk}
      color={formOk ? colors.green : colors.gray}
      loading={loading}
      titleHeader="Novo motorista"
    >
      <Container>
        <Title>Email</Title>

        <StyledForm
          onSubmit={undefined}
          initialValues={{
            email,
          }}
          validationSchema={() => ({
            email: Yup.string().required('Email inválido!').email(),
          })}
        >
          {formControl => (
            <ContainerForm>
              <Input
                label="Qual é o email do motorista?"
                placeholder="Digite o email do motorista"
                name="email"
                formControl={formControl}
                errorMessage={errorMessage}
                onChange={handleChange}
                disabled={!informarEmail}
              />
              <ContainerSwitch>
                <Switch
                  id="status"
                  checked={!informarEmail}
                  onChange={() => setInformarEmail(!informarEmail)}
                />
                <Label>Não quero informar o email</Label>
              </ContainerSwitch>
            </ContainerForm>
          )}
        </StyledForm>
      </Container>
    </Scaffold>
  )
}

export default Email
